import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { RolesFilterOption } from '../models/role-filter-option';
import { RoleRegisterListItem } from '../models/role-register-results.model';

const area = 'Roles Register';
export const roleRegisterAdapterActions = createRegisterActions<RoleRegisterListItem>(area);

export const createRole = createAction(`[${area}] Create Role`);

export const roleRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: RolesFilterOption[] }>()
);

export const loadSystemRolesSuccess = createAction(`[System ${area}] Register Load Success`);

export const loadAccountRolesSuccess = createAction(`[Account ${area}] Register Load Success`);
